import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

const TimelineWrapper = ({
  start,
  end,
  className,
  forceAddMarginBottom = false,
  children
}) => {
  const classes = useStyles()

  return (
    <div
      className={clsx(classes.root, className, {
        [classes.start]: start,
        [classes.end]: end,
        [classes.forceAddMarginBottom]: forceAddMarginBottom
      })}
    >
      {children}
    </div>
  )
}

export default TimelineWrapper
